module.exports = __webpack_public_path__ + "Roboto-Thin.44b78f142603eb69f593.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/css/themes/fonts/roboto/Roboto-Thin.woff
// module id = ../../../../../src/assets/css/themes/fonts/roboto/Roboto-Thin.woff
// module chunks = 0